(function () {
    'use strict';

    // @ngInject
    function OnboardingInvoiceControllerCtor($scope, $injector, $q, $state, $timeout, UsersManager, $window, AnalyticsService, CompaniesManager, ImagesManager, AppStates,
                                              ModalService, PhotosUploadManager, PopupMessageService, OnboardingService, AbTestService, Enums, WorkspaceFileService,NavigationService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'OnboardingGuidanceController';
        AnalyticsService.trackPageView(this, 'View');

        this.$q = $q;
        this.$window = $window;
        this.ModalService = ModalService;
        this.CompaniesManager = CompaniesManager;
        this.ImagesManager = ImagesManager;
        this.PopupMessageService = PopupMessageService;
        this.PhotosUploadManager = PhotosUploadManager;
        this.AnalyticsService = AnalyticsService;
        this.AppStates = AppStates;
        this.OnboardingService = OnboardingService;
        this.$state = $state;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.UsersManager = UsersManager;
        this.WorkspaceFileService = WorkspaceFileService;
        this.NavigationService = NavigationService;
        this.$timeout = $timeout;

        this.currUser = this.UsersManager.getCurrUser();
        this.company = this.CompaniesManager.getCurrCompany();

        this.isCoverImageLoaded = false;
        this.isCoverImageLoading = false;
        this.isCoverImageMobileLoading = false;
        this.selectedCoverImage = null;
        this.formSubmitAttempted = false;

        this.isIconLoaded = false;
        this.isIconLoading = false;
        this.iconLoadingProgress = 0;

        this.fileHeaderAspectRatio = 2.5;
        this.rightAspectRatioHeight = 0;

        this.packageEmailSubject = "Your customized Invoice";
        this.packageEmailDescription = "Hi,\nI would like to share my customized invoice with you.\n You will be able to:\n\t1. Review the invoice of services\n\t2. Make a payment online\n\nWarmly,";
        // this.AbTestService.getAbTestVariation(this.Enums.ABTests.onboardingInvoice).then(function (variation) {
        //     this.showExploreOnMyOwn = variation === 'explore_on_my_own';
        // }.bind(this));

        // calculate the right height for the file cover image to keep the right
        // aspect ratio as it will show up in the end
        $scope.$watch(function () {
            return angular.element('.onboarding-invoice__document-header').width();
        }, function (newValue, oldValue) {
            if (newValue) {
                this.rightAspectRatioHeight = parseInt(newValue / this.fileHeaderAspectRatio);
            }
        }.bind(this));

        this.OnboardingService.triggerPayWallIfOn();
    }

    Controllers.OnboardingInvoiceController = Class(Controllers.BaseController, {
        constructor: OnboardingInvoiceControllerCtor,

        isEmptyFilesCollection: function isEmptyFilesCollection($files) {
            // this happens if the hot-spot is being double clicked (this could be bug on the upload plugin)
            return ($files && $files.length === 0 || !$files);
        },

        findImageInCompanyAccordingToAmazonUrl: function findImageInCompanyAccordingToAmazonUrl(companyCoverImages, s3Url) {
            var imageFound;
            companyCoverImages.forEach(function(image, key) {
                if (image.original_url === s3Url) {
                    imageFound = image;
                }
            });

            return imageFound;
        },

        uploadCoverImageInMobile: function uploadCoverImageInMobile($files) {
            var coverUploadModel = {
                instance: this.company,
                dontUpdateServer: true,
                type: 'cover',
                file: $files[0],
                name: $files[0].name,
                url: null
            };

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_guidance_uploading_file_header_from_mobile);

            this.isCoverImageMobileLoading = true;

            this.PhotosUploadManager.getUpdatedModelData(coverUploadModel);
            this.PhotosUploadManager.uploadPhoto($files, coverUploadModel, this)
                .then(function success(resp) {
                    return this.CompaniesManager.createCompanyImage(this.company, coverUploadModel.file.s3Response, coverUploadModel.type)
                        .then(function createCompanyImageSuccess(result) {
                            this.isCoverImageLoaded = true;

                            this.selectedCoverImage = this.findImageInCompanyAccordingToAmazonUrl(result.data.cover_images, coverUploadModel.file.s3Response.url);

                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.onboarding_guidance_saved_file_header);
                        }.bind(this));
                }.bind(this))
                .catch(function fail(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.onboarding_guidance_saved_file_header, resp);

                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ONBOARDING.GUIDANCE.ERRORS._ERROR_UPLOADING_FILE_');
                }.bind(this))
                .finally(function finallyHandler() {
                    this.isCoverImageLoading = false;
                    this.isCoverImageMobileLoading = false;
                }.bind(this));
        },

        onDocumentHeaderSelected: function onDocumentHeaderSelected($files) {
            if (this.isEmptyFilesCollection($files)) {
                return;
            }
            this.isCoverImageLoading = true;

            if(this.$window.innerWidth < 640){
                // on small screens we dont allow to open the crop dialog.
                // the image will be taken as is and a default cropping will be done on the server side.
                // (take the full width of the image and the height will be taken according to the aspect ratio of 2.5)
                this.uploadCoverImageInMobile($files);
            } else {
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_guidance_opening_crop_dialog);

                this.ModalService.openAttachAssetModal(true, false, true, 'Upload', false, false, null, this.imageDisplayRatio,
                    this.showPreviewWhenCroppingDisplay, $files, 'image/*', '', 'reveal-modal-attach-asset__v2 hide-tabs', 'MEDIA_MODAL.TITLE._ADD_IMAGE_')
                    .then(this.handleSaveRepositionOfSelectedCoverImage.bind(this))
                    .finally(function openAttachAssetModalFinally() {
                        this.isCoverImageLoading = false;
                    }.bind(this));
            }
        },

        openAssetDialogForEditing: function openAssetDialogForEditing() {
            this.isCoverImageLoading = true;

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.onboarding_guidance_opening_crop_dialog_for_editing);

            this.ModalService.openAttachAssetModal(true, false, true, 'Crop', false, false, this.selectedCoverImage, this.imageDisplayRatio,
                this.showPreviewWhenCroppingDisplay, false, 'image/*', '', 'reveal-modal-attach-asset__v2', 'MEDIA_MODAL.TITLE._EDIT_IMAGE_')
                .then(this.handleSaveRepositionOfSelectedCoverImage.bind(this))
                .finally(function openAttachAssetModalFinally() {
                    this.isCoverImageLoading = false;
                }.bind(this));
        },

        handleSaveRepositionOfSelectedCoverImage: function handleSaveRepositionOfSelectedCoverImage(newImage) {
            this.ImagesManager.saveImageReposition(newImage)
                .then(function success(res) {

                    res.data.forEach(function readResult(image) {
                        if (image._type === 'CoverImage') {
                            this.ImagesManager.updateCoverImageInCompany(image);
                        } else if (image._id === newImage._id) {
                            //extend the image we have with the image that was returned from the last API
                            angular.extend(newImage, image);
                        }

                        this.selectedCoverImage = newImage;
                        this.isCoverImageLoaded = true;

                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.onboarding_guidance_saved_file_header);
                    }.bind(this));
                    this.CompaniesManager.setDefaultCoverImage(this.company, this.selectedCoverImage._id);
                }.bind(this))
                .catch(function errorSavingReposition(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.onboarding_guidance_saved_file_header, resp);
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ONBOARDING.GUIDANCE.ERRORS._ERROR_UPLOADING_FILE_');
                }.bind(this))
                .finally(function () {
                    this.isCoverImageLoading = false;
                }.bind(this));
        },

        /***
         * onFileToUploadAsIconAndLogoSelected - will upload the file selected as the company logo and the compay icon
         * later on the user can decide to change ether one of them from the company settings
         * @param $files - the file selected we allow him to select only one
         */
        onFileToUploadAsIconAndLogoSelected: function onFileToUploadAsIconAndLogoSelected($files) {
            if (this.isEmptyFilesCollection($files)) {
                return;
            }
            var fileToUpload = $files[0];

            this.iconLoadingProgress = 0;

            this.isIconLoading = true;
            this.isIconLoaded = false;

            // Upload the icon of the company
            var modelIcon = {
                instance: this.company,
                saveIconAsLogoToo: true, //this will make sure that this file is saved as icon and logo on the company model
                type: 'icon'
            };

            this.PhotosUploadManager.getUpdatedModelData(modelIcon);
            var uploadIconPromise = this.PhotosUploadManager.uploadPhoto($files, modelIcon, this);

            uploadIconPromise
                .then(function successIconAndLogo() {
                    this.isIconLoaded = true;
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.onboarding_guidance_icon_and_logo_updated);
                }.bind(this))
                .catch(function fail(resp) {
                    this.isIconLoaded = false;
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.onboarding_guidance_icon_and_logo_updated, resp);

                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ONBOARDING.GUIDANCE.ERRORS._ERROR_UPLOADING_FILE_');
                }.bind(this))
                .finally(function iconUploaderFinallyHandler() {
                    this.isIconLoading = false;
                }.bind(this));

            fileToUpload.uploadAPI.progress(function (uploadProgress) {
                this.iconLoadingProgress = uploadProgress;
            }.bind(this));

        },

        shouldShowFileSelectionHotSpot: function shouldShowFileSelectionHotSpot() {
            return (!this.isCoverImageLoading && !this.isCoverImageLoaded) ||
                ( this.$window.innerWidth < 640 && !this.isCoverImageLoading && this.isCoverImageLoaded);
        },

        onStartNextClicked: function onStartNextClicked() {
            this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.invoiceStart);
        },

        onBrandNextClicked: function onBrandNextClicked() {
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.click_onboarding_add_brands_next, {
                logo_uploaded: this.isIconLoaded, header_uploaded: this.isCoverImageLoaded
            });

            this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.invoiceBrand);
        },

        onPackageNextClicked: function onPackageNextClicked() {
            if (this.invoicePackageForm.package_name.$error.required) {
                this.formSubmitAttempted = true;
                return;
            }
            var fieldsComplete = 0;
            if (this.packageName) {
                fieldsComplete++;
            }
            if (this.packageAmount) {
                fieldsComplete++;
            }
            if (this.packageDescription) {
                fieldsComplete++;
            }
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.click_onboarding_add_service_next, {
                fields_complete: fieldsComplete
            });
            this.UsersManager.createFirstInvoice(this.packageName, this.packageAmount,
                this.packageDescription).then(function (resp) {
                this.currUser.last_event_visited = resp.data._id;
                this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.invoicePackage);
            }.bind(this));
        },

        onEmailNextClicked: function onEmailNextClicked() {
            this.WorkspaceFileService.gotoWorkspaceFileById(this.currUser.last_event_visited, null, null, false);
            this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.invoiceEmail);
        },

        closeOnboarding: function closeOnboarding() {
            this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.createEventTooltip);
            this.$state.go(this.AppStates.root_core_navigation_pipeline);
        },
    });
}());